<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <!-- Breadcrumb y ayuda -->
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <div class="breadcrumb-container">
            <router-link to="/prestador">Prestador</router-link>
            > {{ datoPrestador.razonSocial }}
          </div>
        </div>
        <div class="col-1">
          <span
            class="material-symbols-outlined"
            style="font-size: 32px; color: blue; cursor: pointer"
            @click="showModalHelp = true"
          >
            help
          </span>
        </div>
      </div>
    </div>
    <!-- Master -->
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <form>
          <div class="modal-body">
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <strong>Razón Social</strong>
                </div>
                <div class="col-7">
                  <span style="text-transform: uppercase">{{
                    datoPrestador.razonSocial
                  }}</span>
                </div>
                <div class="col-1">
                  <strong>Id.</strong>
                </div>
                <div class="col-2">
                  <span>{{ datoPrestador.idPrestador }}</span>
                </div>
              </div>
            </div>

            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <strong>Nombre Comercial</strong>
                </div>
                <div class="col-7">
                  <span style="text-transform: uppercase">{{
                    datoPrestador.nombreComercial
                  }}</span>
                </div>
                <div class="col-1">
                  <strong>Ruc</strong>
                </div>
                <div class="col-2">
                  <span style="text-transform: uppercase">{{
                    datoPrestador.ruc
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Details -->
    <hr />
    <div class="mb-3">
      <table class="tablaBusqueda">
        <tr>
          <td><label for="nombre" class="form-label">Nombre</label></td>
          <td>
            <input
              type="text"
              class="form-control"
              id="nombreBusqueda"
              name="nombreBusqueda"
              v-model="nombreBusqueda"
              style="width: 500px; text-transform: uppercase"
              required
            />
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPagina(1)"
              title="Buscar registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >search</i
              >
              Buscar
            </button>
          </td>
          <td class="centro">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="getDataPaginaTodos(1)"
              title="Todos los registros"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: blue; cursor: pointer"
                >auto_awesome_motion</i
              >
            </button>
          </td>
          <td>
            <button
              type="submit"
              class="btn btn-light"
              data-bs-toggle="modal"
              data-bs-target="#ventanaModal"
              @click="abrirModalCrear"
              title="Nuevo registro"
            >
              <i
                class="material-icons"
                style="font-size: 24px; color: green; cursor: pointer"
                >add_box</i
              >Nuevo Registro
            </button>
          </td>
        </tr>
      </table>
    </div>
    <table id="sampleTable" class="table table-hover">
      <thead>
        <tr>
          <th scope="col">Código</th>
          <th scope="col">Nombre</th>
          <th scope="col">Opciones</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="elempres in datosPaginados"
          :key="elempres.idElemPres"
          @dblclick="handleRowClick($event, elempres.idElemPres)"
        >
          <td>{{ elempres.codigo }}</td>
          <td>{{ elempres.nombre }}</td>
          <td>
            <select
              class="form-select form-select-sm"
              @change="handleAction($event, elempres.idElemPres)"
            >
              <option disabled selected>Seleccione...</option>
              <option value="resumen">Editar</option>
              <option value="detalles">Elementos</option>
              <option value="borrar">Borrar</option>
            </select>
          </td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()">
          <a class="page-link" href="#">Anterior</a>
        </li>
        <li
          id="lugar"
          v-for="pagina in totalPaginas()"
          v-bind:key="pagina"
          v-on:click="getDataPagina(pagina)"
          class="page-item"
          v-bind:class="isActive(pagina)"
        >
          <a class="page-link" href="#">{{ pagina }}</a>
        </li>
        <li class="page-item" v-on:click="getNextPage()">
          <a class="page-link" href="#">Siguiente</a>
        </li>
      </ul>
    </nav>
    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title" id="exampleModalLabel">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <div class="mb-3" v-if="btnEditar_det">
                <div class="row">
                  <div class="col-2">
                    <label for="idElemPres" class="form-label">Id.</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="idElemPres"
                      name="idElemPres"
                      v-model="datoElemPres.idElemPres"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!--			
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idPrestador" class="form-label">IdPrestador</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idPrestador" name="idPrestador" v-model="datoElemPres.idPrestador" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
-->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="codigo" class="form-label">Codigo</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="codigo"
                      name="codigo"
                      v-model="datoElemPres.codigo"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label for="nombre" class="form-label">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      id="nombre"
                      name="nombre"
                      v-model="datoElemPres.nombre"
                      style="text-transform: uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarElemPres"
              v-if="btnCrear_det"
              title="Guardar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >save</i
              >
            </button>
            <button
              type="submit"
              class="btn btn-light"
              @click.prevent="guardarEditElemPres"
              v-if="btnEditar_det"
              title="Actualizar"
            >
              <i
                class="material-icons"
                style="font-size: 32px; color: blue; cursor: pointer"
                >update</i
              >
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Details -->

    <Footer />
  </div>
</template>
<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api from "@/services/api";
import { validarForm } from "../../modules/validacionesForms.js";
import dateFormat from "../../modules/dateFormat.js";

import * as $ from "jquery";
window["$"] = $;
window["jQuery"] = $;
import swal from "sweetalert";
export default {
  components: {
    Layout,
    Footer,
  },
  data() {
    return {
      // Variables master
      prestadors: [],
      datoPrestador: {},
      nombreBusqueda: "",
      titulo: "",
      btnCrear: false,
      btnEditar: false,
      p_idPrestador: "",
      // Variables master
      // Variables details
      elempress: [],
      datoElemPres: {},
      nombreBusqueda_det: "",
      titulo_det: "",
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      modalWindow: true,
      // Variables details
    };
  },
  mounted() {
    this.p_idPrestador = this.$route.params.p_idprestador;
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.abrirEditar(this.p_idPrestador);
    this.getDataPaginaTodos(this.paginaActual);
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    handleRowClick(event, idElemPres) {
      if (
        event.target.tagName === "SELECT" ||
        event.target.tagName === "OPTION"
      ) {
        return;
      }
      this.abrirEditarDet(idElemPres);
    },
    handleAction(event, idElemPres) {
      const action = event.target.value;
      if (action === "resumen") {
        this.abrirModalEditar(idElemPres);
      } else if (action === "detalles") {
        this.abrirEditarDet(idElemPres);
      } else if (action === "borrar") {
        this.deleteElemPres(idElemPres);
      }

      event.target.value = "Seleccione...";
    },
    // Procedimientos master
    validarForm() {
      const requiredFields = ["razonSocial", "nombreComercial", "ruc"];
      const requiredFieldsText = ["razonSocial", "nombreComercial", "ruc"];
      return validarForm(
        this.datoPrestador,
        requiredFields,
        requiredFieldsText
      );
    },
    abrirCrear() {
      this.modalWindow = true;
      this.datoPrestador = {};
      this.titulo = "Crear ";
      this.btnCrear = true;
      this.btnEditar = false;
    },
    abrirEditar(idPrestador) {
      this.modalWindow = true;
      if (idPrestador != null) {
        api.get("/vwprestadors/" + idPrestador)
          .then((resp) => {
            this.datoPrestador = resp.data;
          });
      }
      this.titulo = "Editar ";
      this.btnCrear = false;
      this.btnEditar = true;
    },
    cerrarPrestador() {
      this.$router.push("/Prestador");
    },
    // Procedimientos master
    // Procedimientos detalle
    totalPaginas() {
      return Math.ceil(this.elempress.length / this.elementosPorPagina);
    },
    getDataPagina(noPagina) {
      if (this.nombreBusqueda != "") {
        api.get("/vwelempress/nombre/" +
              this.nombreBusqueda
          )
          .then((response) => {
            this.elempress = response.data.reverse();
            this.paginaActual = noPagina;
            this.datosPaginados = [];
            let ini =
              noPagina * this.elementosPorPagina - this.elementosPorPagina;
            let fin = noPagina * this.elementosPorPagina;
            this.datosPaginados = this.elempress.slice(ini, fin);
          });
      }
    },
    getDataPaginaTodos(noPagina) {
      api.get("/vwelempress/idprestador/" +
            this.p_idPrestador
        )
        .then((response) => {
          this.elempress = response.data.reverse();
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini =
            noPagina * this.elementosPorPagina - this.elementosPorPagina;
          let fin = noPagina * this.elementosPorPagina;
          this.datosPaginados = this.elempress.slice(ini, fin);
        });
    },
    getPreviousPage() {
      if (this.paginaActual > 1) {
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage() {
      if (this.paginaActual < this.totalPaginas()) {
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina) {
      return noPagina == this.paginaActual ? "active" : "";
    },
    validarFormDet() {
      const requiredFields = ["razonSocial", "nombreComercial", "ruc"];
      const requiredFieldsText = ["razonSocial", "nombreComercial", "ruc"];
      return validarForm(
        this.datoPrestador,
        requiredFields,
        requiredFieldsText
      );
    },
    async guardarElemPres() {
      if (this.validarForm() === 1) {
        try {
          this.datoElemPres.idPrestador = this.datoPrestador.idPrestador;
          await api.post("/elempress",
            this.datoElemPres
          );
          $("#ventanaModal").modal("hide");
          swal("Correcto!", "ElemPres creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditElemPres() {
      if (this.validarForm() === 1) {
        try {
          await api.post("/elempress",
            this.datoElemPres
          );
          $("#ventanaModal").modal("hide");
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "ElemPres creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors);
          array.forEach((element) => swal(String(element)));
        }
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoElemPres = {};
      this.titulo = "Crear ";
      this.btnCrear_det = true;
      this.btnEditar_det = false;
    },
    abrirModalEditar(idElemPres) {
      this.modalWindow = true;
      if (idElemPres != null) {
        api.get("/vwelempress/" + idElemPres)
          .then((resp) => {
            this.datoElemPres = resp.data;
          });
      }
      $("#ventanaModal").modal("show");
      this.titulo = "Editar ";
      this.btnCrear_det = false;
      this.btnEditar_det = true;
    },
    abrirEditarDet(idElemPres) {
      this.modalWindow = true;
      if (idElemPres != null) {
        this.$router.push("/elempres_elemequi/" + idElemPres);
      }
    },
    async deleteElemPres(idElemPres) {
      try {
        await api.delete("/elempress/" + idElemPres
        );
        this.getDataPagina(this.paginaActual);
      } catch (error) {
        alert("No se pudo eliminar");
      }
    },
  },
};
</script>
<style scoped>
.table-hover tbody tr {
  cursor: pointer; /* Cambia el cursor a una mano al pasar sobre la fila */
}
</style>
